import React from 'react';

const TextContent = props => (
    <div className="text-content">
        {props.children}
    </div>
);

export default TextContent;